<div class="responsive-card">
  <div ngbAccordion class="d-flex flex-column">
    <app-remittance-item-header
      [remittance]="remittance$ | async"
      [showActionButton]="showActionButton"
      [accordionExpanded]="accordionExpanded$ | async"
      [isLoading]="isLoading"
      (headerClicked)="headerClicked()" />
    <div ngbAccordionItem [collapsed]="!(accordionExpanded$ | async)">
      <div ngbAccordionCollapse>
        <div class="pt-4 d-flex flex-column gap-4">
          <hr class="m-0" />
          <app-remittance-item-details
            ngbAccordionBody
            [remittance]="remittance$ | async"
            [showEmployerInfo]="showEmployerInfo"
            [showSource]="showSource"
            [contributionSummary]="contributionSummary$ | async"
            [isLoading]="isLoading" />
          <ng-container *ngIf="isLoading">
            <hr class="m-0" />
            <div class="mb-3">
              <lib-loading-shimmer [height]="'1rem'" [width]="'5rem'" />
            </div>
            <lib-loading-shimmer [borderRadius]="'0.5rem'" [height]="'3.875rem'" [width]="'100%'" />
          </ng-container>
          <ng-container *ngIf="showTransactions && (transactionsToDisplay$ | async)?.length > 0 && !isLoading">
            <hr class="m-0" />
            <div class="title-sm" i18n>Transactions</div>
            <div class="d-flex flex-column gap-3">
              <app-remittance-transaction-preview-card
                *ngFor="let trans of transactionsToDisplay$ | async"
                [transaction]="trans"
                (viewTransactionClick)="viewTransactionClick.emit($event)" />
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
